import { Form, Input, Button } from 'antd';
import { LockOutlined, MailOutlined } from '@ant-design/icons';
import { useLogin } from '../../hooks/useAuth';
import type { AdminLoginRequest } from '../../types/auth';

export function LoginPage() {
  const login = useLogin();

  const onFinish = (values: AdminLoginRequest) => {
    login.mutate(values);
  };

  return (
    <Form layout="vertical" onFinish={onFinish} autoComplete="off">
      <Form.Item name="email" rules={[{ required: true, type: 'email', message: 'Please enter a valid email' }]}>
        <Input prefix={<MailOutlined />} placeholder="Email" size="large" />
      </Form.Item>
      <Form.Item name="password" rules={[{ required: true, message: 'Please enter your password' }]}>
        <Input.Password prefix={<LockOutlined />} placeholder="Password" size="large" />
      </Form.Item>
      <Form.Item>
        <Button type="primary" htmlType="submit" loading={login.isPending} block size="large">
          Sign In
        </Button>
      </Form.Item>
    </Form>
  );
}
